var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDelete = function SvgDelete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_4745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 0H6C2.68629 0 0 2.68629 0 6V59C0 62.3137 2.68629 65 6 65H59C62.3137 65 65 62.3137 65 59V6C65 2.68629 62.3137 0 59 0Z",
    fill: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 24.2H46V26.8H43.4V43.7C43.4 44.0448 43.263 44.3754 43.0192 44.6192C42.7754 44.863 42.4448 45 42.1 45H23.9C23.5552 45 23.2246 44.863 22.9808 44.6192C22.737 44.3754 22.6 44.0448 22.6 43.7V26.8H20V24.2H26.5V20.3C26.5 19.9552 26.637 19.6246 26.8808 19.3808C27.1246 19.137 27.4552 19 27.8 19H38.2C38.5448 19 38.8754 19.137 39.1192 19.3808C39.363 19.6246 39.5 19.9552 39.5 20.3V24.2ZM29.1 30.7V38.5H31.7V30.7H29.1ZM34.3 30.7V38.5H36.9V30.7H34.3ZM29.1 21.6V24.2H36.9V21.6H29.1Z",
    fill: "#242526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_4745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.4065b75763d42ce411d89a863a20b4a7.svg";